"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsVatNumberValidator = void 0;
exports.isVatNumber = isVatNumber;
const class_validator_1 = require("class-validator");
let IsVatNumberValidator = class IsVatNumberValidator {
    validate(input) {
        if (!input) {
            return false;
        }
        return isVatNumber(input);
    }
    defaultMessage() {
        return "VAT number is in wrong format.";
    }
};
exports.IsVatNumberValidator = IsVatNumberValidator;
exports.IsVatNumberValidator = IsVatNumberValidator = __decorate([
    (0, class_validator_1.ValidatorConstraint)({ name: "is vat number" })
], IsVatNumberValidator);
function isVatNumber(input) {
    return /^[A-Z]{2}.{2,13}$/.test(input);
}
//# sourceMappingURL=IsVatNumberValidator.js.map